import { render, staticRenderFns } from "./Choose.vue?vue&type=template&id=0dad329b&"
import script from "./Choose.vue?vue&type=script&lang=js&"
export * from "./Choose.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports